import { RepositoryFactory } from "../../repository/RepositoryFactory";

let leads = RepositoryFactory.get("leads");
const state = {
  getLoader: false,
  id: "",
  fName: "",
};

const getters = {
  videodeurbelveiligLoader: (state) => state.getLoader,
  videodeurbelveiligprofId: (state) => state.id,
  videodeurbelveiligname: (state) => state.fName,
};

const actions = {
  async videodeurbelveiligLead({ commit }, payload) {
    commit("setGetLoader", true);
    commit("name", payload.firstname);
    try {
      const response = await leads.videodeurbelveiligLead(payload);
      commit("setGetLoader", false);
      const responseid = response.data.profile.id;
      commit("id", responseid);
      return {
        success: true,
        profileid: responseid,
      };
    } catch (error) {
      commit("setGetLoader", false);
      alert(error.response.data.error);
      return {
        success: false,
      };
    }
  },
};

const mutations = {
  setGetLoader(state, payload) {
    state.getLoader = payload;
  },
  id(state, payload) {
    state.id = payload;
  },
  name(state, payload) {
    state.fName = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
